import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import { hasOwnPropertyTS } from '@components/utils';



const About = () => {
	const { t } = useTranslation('web');

	return (
		<div className='footer-menu about-section'>

			<Link to={NavigateRoutes.about}>
				{t('layouts.footer.aboutSection.aboutUs')}
			</Link>

			<Link to={NavigateRoutes.history}>
				{t('layouts.footer.aboutSection.history')}
			</Link>

			<Link to={NavigateRoutes.partners}>
				{t('layouts.footer.aboutSection.partners')}
			</Link>

			<Link to={'#'} onClick={() => {
					if (hasOwnPropertyTS(window, 'Cookiebot')
						&& window.Cookiebot
						&& hasOwnPropertyTS(window.Cookiebot, 'show')
						&& window.Cookiebot.show) {
							(window.Cookiebot as any).show();
						}
				}}>
				{t('layouts.footer.aboutSection.changeCookiesConsent')}
			</Link>

			<br />

			<Link to={NavigateRoutes.contact}>
				{t('layouts.footer.aboutSection.contact')}
			</Link>

			<p className='contact-phone-number'>{t('layouts.footer.aboutSection.phoneNumberLabel')} <span>{t('shared.contactPhoneNumber')}</span></p>
			
		</div>
	);
}

export default About;